const types = {
  SET_CASE_TICKETS_LIST_LOADING: "SET_CASE_TICKETS_LIST_LOADING",
  SET_CASE_TICKETS_LIST: "SET_CASE_TICKETS_LIST",
  SET_CASE_TICKET_NOTIFICATION_COUNT: "SET_CASE_TICKET_NOTIFICATION_COUNT",
  SET_NOTIFICATIONS_COUNT_BY_TICKET_IDS: "SET_NOTIFICATIONS_COUNT_BY_TICKET_IDS",
};

export default types;
